export class LicensePlateTypeRequest {
  onlyTrailerPlates: boolean;
}